import { render, staticRenderFns } from "./CircularProgressWidget.vue?vue&type=template&id=49043b1a&scoped=true"
import script from "./CircularProgressWidget.vue?vue&type=script&lang=ts"
export * from "./CircularProgressWidget.vue?vue&type=script&lang=ts"
import style0 from "./CircularProgressWidget.vue?vue&type=style&index=0&id=49043b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49043b1a",
  null
  
)

export default component.exports